var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElliptical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2.46154C18 3.53805 17.309 4.45315 16.3463 4.78746C16.3344 6.88545 14.941 9.52222 12.5218 11.6252C10.2107 13.6342 7.5475 14.6484 5.50135 14.4907C5.12908 15.3773 4.25264 16 3.23077 16C1.8713 16 0.769229 14.8979 0.769229 13.5385C0.769229 12.5303 1.37532 11.6637 2.24301 11.2831C2.13879 9.14755 3.54535 6.38206 6.06215 4.19424C8.47107 2.1002 11.2625 1.08702 13.339 1.35511C13.7441 0.551329 14.5769 -1.49628e-07 15.5385 -1.07597e-07C16.8979 -4.81729e-08 18 1.10207 18 2.46154ZM5.52847 12.6536C5.27387 11.9929 4.74252 11.4697 4.07648 11.2261C3.97354 9.80676 5.06728 7.50525 7.27333 5.58755C9.4187 3.72261 11.7771 2.94992 13.1847 3.18424C13.3915 3.85846 13.88 4.40946 14.5129 4.69992C14.5558 6.12589 13.4623 8.36147 11.3106 10.2319C9.22963 12.0409 6.94817 12.8222 5.52847 12.6536Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElliptical);
export default __webpack_public_path__ + "static/media/elliptical.e214729e4a26586d33faf3f6cc47a1a1.svg";
export { ForwardRef as ReactComponent };